import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

function AddAiGenerators({ closeModal, onAiAdded }) {
    // Load initial state from sessionStorage, or use an empty object
    const [formData, setFormData] = useState(() => {
        const savedData = sessionStorage.getItem('aiGeneratorFormData');
        return savedData ? JSON.parse(savedData) : {
            type: '',
            siteUrl: '',
            description: ''
        };
    });

    // Save formData to sessionStorage whenever it changes
    useEffect(() => {
        sessionStorage.setItem('aiGeneratorFormData', JSON.stringify(formData));
    }, [formData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/aigenerators`, formData);
            toast.success('AI Generator added');
            onAiAdded();
            closeModal();
            // Clear sessionStorage after a successful submission
            sessionStorage.removeItem('aiGeneratorFormData');
        } catch (err) {
            toast.error('Error adding AI Generator');
        }
    };
 

  return (
    <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow space-y-4">
      <div>
        <label className="block font-medium">Type</label>
        <select name="type" value={formData.type} onChange={handleChange} required className="w-full border px-3 py-2 rounded">
          <option value="">Select Type</option>
          <option value="Image Generator">Image Generator</option>
          <option value="Video Generator">Video Generator</option>
        </select>
      </div>

      <div>
        <label className="block font-medium">Site URL</label>
        <input type="url" name="siteUrl" value={formData.siteUrl} onChange={handleChange} required className="w-full border px-3 py-2 rounded" />
      </div>

      <div>
        <label className="block font-medium">Description</label>
        <textarea name="description" value={formData.description} onChange={handleChange} required className="w-full border px-3 py-2 rounded" />
      </div>

      <div className="flex gap-2">
        <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">Add</button>
        <button onClick={closeModal} type="button" className="bg-gray-300 px-4 py-2 rounded">Cancel</button>
      </div>
    </form>
  );
}

export default AddAiGenerators;
